import React from 'react';
import {FastField} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import FormGroupField from '../FormGroupField';
import {fontLabels} from '../../../constants';
import {getCssValueForFontFamily, getEmbedCodeForFont} from '../../../utils/branding';


const ButtonForm = ({buttonBranding}) => {
    const [css, setCss] = React.useState('');
    React.useEffect(() => {
        const style = `
                  ${getEmbedCodeForFont(buttonBranding.font)}
                  button.custom_button {
                      background-color: ${buttonBranding.backgroundColor} !important;
                      color: ${buttonBranding.textColor} !important;
                      font-family: ${getCssValueForFontFamily(buttonBranding.font)} !important;
                      font-size: ${buttonBranding.fontSize}px !important;
                      padding: ${buttonBranding.paddingVertical}px ${buttonBranding.paddingHorizontal}px  !important;
                      border-color: ${buttonBranding.borderColor} !important;
                      border-width: ${buttonBranding.borderWidth}px !important;
                      border-radius: ${buttonBranding.borderRadius}px !important;
                  }
                  button.custom_button:hover {
                      background-color: ${buttonBranding.backgroundHoverColor} !important;
                      color: ${buttonBranding.textHoverColor} !important;
                      border-color: ${buttonBranding.borderHoverColor} !important;
                  }`;
        setCss(style);
    }, [buttonBranding]);

    return <div>
        <div className="row">
            <div className="col">
                <label className="col-form-label" htmlFor="branding-buttons-font"><FormattedMessage {...messages.admin.branding.uiForms.font} /></label>
                <FastField id="branding-font" name="ui.buttons.font" className="form-control custom-select" component="select">
                    {fontLabels.map(({key, label}) => (<option key={`font_${key}`} value={key}>{label}</option>))}
                </FastField>
            </div>
            <div className="col">
                <FormGroupField type="color" id="branding-text_color" name="ui.buttons.textColor"
                    label={messages.admin.branding.uiForms.textColor} />
            </div>
            <div className="col">
                <FormGroupField type="color" id="branding-text_hover_color" name="ui.buttons.textHoverColor"
                    label={messages.admin.branding.uiForms.textHoverColor} />
            </div>
            <div className="col">
                <FormGroupField type="number" id="branding-font_size" name="ui.buttons.fontSize"
                    label={messages.admin.branding.uiForms.fontSize} />
            </div>
        </div>
        <div className="row">
            <div className="col">
                <FormGroupField type="color" id="branding-background_color" name="ui.buttons.backgroundColor"
                    label={messages.admin.branding.uiForms.backgroundColor} />
            </div>
            <div className="col">
                <FormGroupField type="color" id="branding-background_hover_color" name="ui.buttons.backgroundHoverColor"
                    label={messages.admin.branding.uiForms.backgroundHoverColor} />
            </div>
            <div className="col">
                <FormGroupField type="number" id="branding-padding_vertical" name="ui.buttons.paddingVertical"
                    label={messages.admin.branding.uiForms.paddingVertical} />
            </div>
            <div className="col">
                <FormGroupField type="number" id="branding-padding_horizontal" name="ui.buttons.paddingHorizontal"
                    label={messages.admin.branding.uiForms.paddingHorizontal} />
            </div>
        </div>
        <div className="row">
            <div className="col">
                <FormGroupField type="color" id="branding-border_color" name="ui.buttons.borderColor"
                    label={messages.admin.branding.uiForms.borderColor} />
            </div>
            <div className="col">
                <FormGroupField type="color" id="branding-border_hover_color" name="ui.buttons.borderHoverColor"
                    label={messages.admin.branding.uiForms.borderHoverColor} />
            </div>
            <div className="col">
                <FormGroupField type="number" id="branding-border_width" name="ui.buttons.borderWidth"
                    label={messages.admin.branding.uiForms.borderWidth} />
            </div>
            <div className="col">
                <FormGroupField type="number" id="branding-border_radius" name="ui.buttons.borderRadius"
                    label={messages.admin.branding.uiForms.borderRadius} />
            </div>
        </div>
        <div className="row">
            <div className="col">
                <style>
                    {css}
                </style>
                <button type="button" className="btn btn-primary custom_button">Preview Button</button>
            </div>
        </div>
    </div>;
};

export default ButtonForm;
